const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'upload',
        meta: { title: 'pages.upload.title', anonymous: true },
        component: () => import('@/views/Upload.vue'),
      },
      {
        // Pretty guest link the keeper hands out: /s/<token> (or /a/<token>)
        // carries the album link token in the path, so guests never type it.
        // One link = one album: the same page shows favorites + progress and
        // accepts new photos.
        path: 's/:token',
        name: 'share',
        meta: { title: 'pages.upload.title', anonymous: true },
        component: () => import('@/views/Upload.vue'),
      },
      {
        path: 'a/:token',
        name: 'guest',
        meta: { title: 'pages.upload.title', anonymous: true },
        component: () => import('@/views/Upload.vue'),
      },
      {
        // Backwards-compatible alias for the old album-view link.
        path: 'album/:token',
        name: 'album',
        meta: { title: 'pages.album.title', anonymous: true },
        component: () => import('@/views/Upload.vue'),
      },
      {
        path: 'accessibility',
        name: 'accessibility',
        meta: { title: 'pages.accessibility.title', anonymous: true },
        component: () => import('@/views/Accessibility.vue'),
      },
      {
        path: ':pathMatch(.*)*',
        name: 'notFound',
        meta: { title: 'pages.notFound.title', anonymous: true },
        component: () => import('@/views/NotFound.vue'),
      },
    ],
  },
];

export default routes;
